import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { Button } from "@/components/ui/button";

/**
 * A URL that names nothing.
 *
 * Both diagnostics detail screens read a numeric id out of the path and pass
 * it straight to a fetch. A junk segment produced `NaN`, which the hooks
 * refuse to request — leaving the coach on a skeleton that never resolved —
 * and, on the company page, reached `NewDiagnosticDialog` as a locked `NaN`
 * company. This is a render state, not an error: nothing failed, the address
 * is simply wrong, so there is no toast to withhold from the global
 * interceptor.
 */
export const DiagnosticNotFound: React.FC<{ message: string }> = ({
  message,
}) => {
  const navigate = useNavigate();

  return (
    <MainPageWrapper title="Not found">
      <Button
        onClick={() => navigate("/admin/diagnostics")}
        size="sm"
        variant="ghost"
      >
        <ArrowLeft className="mr-1 h-4 w-4" />
        Back to companies
      </Button>

      <div className="mt-6 rounded-lg border border-gray-200 bg-white p-8 text-center dark:border-slate-700 dark:bg-slate-800">
        <p className="text-sm text-gray-900 dark:text-white">{message}</p>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Check the address, or pick one from the companies list.
        </p>
      </div>
    </MainPageWrapper>
  );
};

export default DiagnosticNotFound;
